import gql from 'graphql-tag'
import api from '../apiClient'

export default {
  readByEmisor: (emisor, cursor, limit, searchString) =>
    api
      .send({
        query: gql`
          query READ_ALL($emisor: ID!, $cursor: String, $limit: Int, $searchString: String) {
            AutoEmail {
              readByEmisor(emisor: $emisor, cursor: $cursor, limit: $limit, searchString: $searchString) {
                feed {
                  _id
                  # doc
                  provider
                  error
                  status
                  createdAt
                }
                pageInfo {
                  nextPageCursor
                  hasNextPage
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          cursor,
          limit,
          searchString
        }
      })
      .then(result => result.data.data.AutoEmail.readByEmisor),

  readById: _id =>
    api
      .send({
        query: gql`
          query READ_ID($_id: ID!) {
            AutoEmail {
              readById(_id: $_id) {
                _id
                doc
                provider
                error
                status
                createdAt
              }
            }
          }
        `,
        variables: {
          _id
        }
      })
      .then(result => result.data.data.AutoEmail.readById)
}
